import React from "react";

import "./Chat-Title.css";

function ChatTitle() {
  return (
    <div id="chat-title">
      <span>Chat</span>
    </div>
  );
}

export default ChatTitle;
